import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import objectPath from 'object-path';
import Container from '../../container';
import AboutPlayButton from '../../about/about-play-button';
import { YTModalContext } from '../../with-youtube-modal';
import AboutHeroTextWave from '../../about-hero-text-wave';

const aboutHeroPlayButton = `
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${screen.below(bp.mobile, `
    top: calc(50% + 27px);
  `)};
`;

const AboutHero = ({ topTitle, bottomTitle, images, videoLink }) => {
  const [image1, image2] = images;

  return (
    <AboutHeroSection>
      <AboutHeroTop>

        {objectPath.has(image1, 'fields.file.url') &&
          <AboutHeroImageWrap>
            <img
              srcSet={`${image1.fields.file.url}?w=750&h=394&q=75&fit=thumb&fm=jpg&fl=progressive 750w,
                       ${image1.fields.file.url}?w=1800&h=944&q=80&fit=thumb&fm=jpg&fl=progressive 1800w`}
              src={`${image1.fields.file.url}?w=1800&h=944&q=80&fit=thumb&fm=jpg&fl=progressive`}
              alt={image1.fields.description}
            />
          </AboutHeroImageWrap>
        }

        <Container>
          <AboutHeroTextWave>
            {topTitle}
          </AboutHeroTextWave>
        </Container>

      </AboutHeroTop>

      <AboutHeroBottom>

        {objectPath.has(image2, 'fields.file.url') &&
          <AboutHeroImageWrap>
            <img
              srcSet={`${image2.fields.file.url}?w=750&h=394&q=75&fit=thumb&fm=jpg&fl=progressive 750w,
                       ${image2.fields.file.url}?w=1800&h=944&q=80&fit=thumb&fm=jpg&fl=progressive 1800w`}
              src={`${image2.fields.file.url}?w=1800&h=944&q=80&fit=thumb&fm=jpg&fl=progressive`}
              alt={image2.fields.description}
            />
          </AboutHeroImageWrap>
        }

        <Container>
          <AboutHeroTextWave scrollIn>
            {bottomTitle}
          </AboutHeroTextWave>
        </Container>

      </AboutHeroBottom>

      {videoLink &&
        <YTModalContext.Consumer>
          {context => (
            <AboutPlayButton
              styles={aboutHeroPlayButton}
              onClick={(e) => { context.toggleModal(e, videoLink); }}
              aria-label="Open video modal"
            />
          )}
        </YTModalContext.Consumer>
      }

    </AboutHeroSection>
  );
};

const AboutHeroSection = styled.section`
  position: relative;
  text-align: center;
  overflow: hidden;
`;

const AboutHeroTop = styled.div`
  position: relative;
  padding: 350px 0 100px;
  margin-bottom: 31px;

  ${screen.below(bp.tablet, `
    padding: 250px 0 100px;
  `)}

  ${screen.below(bp.portrait, `
    padding: 175px 0 100px;
  `)};

  ${screen.below(bp.mobile, `
    padding: 154px 0 50px;
  `)};
`;

const AboutHeroBottom = styled.div`
  position: relative;
  padding: 100px 0 350px;
  margin-top: 31px;

  ${screen.below(bp.tablet, `
    padding: 100px 0 250px;
  `)}

  ${screen.below(bp.portrait, `
    padding: 100px 0 175px;
  `)};

  ${screen.below(bp.mobile, `
    padding: 50px 0 100px;
  `)};
`;

const AboutHeroImageWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

AboutHero.propTypes = {
  topTitle: PropTypes.string,
  bottomTitle: PropTypes.string,
  images: PropTypes.array,
  videoLink: PropTypes.string,
};

AboutHero.defaultProps = {
  images: [],
};

export default AboutHero;
